import { Alert, Card, Col, Row, Skeleton } from 'antd';
import { ConnectedChannelsItem } from 'components/ConnectedChannelsItem';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { Number } from 'interfaces/number';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ConnectedChannelsProps {
  number: Number;
}

function ConnectedChannels({ number }: ConnectedChannelsProps) {
  return (
    <Card
      title={<FormattedMessage id="connected_channels_title" />}
      style={{ width: 'auto', margin: 5 }}
    >
      <Skeleton loading={number.loadingConnectedChannels}>
        {number.connected_channels.length > 0 ? (
          <>
            <div
              style={{
                backgroundColor: '#e8f9fe',
                padding: 12,
                borderBottom: '1px solid #fff',
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{ lineHeight: '25px', fontWeight: 'bold' }}
                >
                  <FormattedMessage id="numbers_form_nickname" />
                </Col>
                <Col
                  span={12}
                  style={{ lineHeight: '25px', fontWeight: 'bold' }}
                >
                  <FormattedMessage id="channel_name" />
                </Col>
              </Row>
            </div>
            {number.connected_channels.map((channel) => (
              <ConnectedChannelsItem
                key={channel.id}
                numberName={channel.name !== '' ? channel.name : channel.number}
                channelName={channel.channel_name}
              />
            ))}
          </>
        ) : (
          <Alert
            message={<FormattedMessage id="not_found_registers" />}
            type="warning"
            showIcon
          />
        )}
      </Skeleton>
    </Card>
  );
}

export default NumberConsumer(ConnectedChannels);
